import React, { Component } from "react";
import PropTypes from "prop-types";

import * as actions from "../../../redux/modules/actions";

import {
  tr,
  th,
  td,
  thead,
  Table,
  Row,
  Col,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
} from "react-bootstrap";
import renderHTML from "react-render-html";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import { siteActions } from "../../../redux/actions/siteActions";
import {
  renderAlert,
  clearAlert,
  alertsActions
} from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

class SiteLookup extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'GENERAL_SEARCH',
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      orderID: "",
      voucherID: "",
      archivevoucherID :"",
      couponID: "",
      trackingNumber: "",
      transaction_id: "",
      address: "",
      lookupData: {},
      loading: true,
      isVoucherLookupActive: false,
      subscriber_email: '',
      subscriber_fname: '',
      subscriber_lname: '',
      isCouponLookupActive: false,
      isAddressLookupActive: false,
      isTrackingLookupActive: false,
      isTransactionLookupActive: false,
      path: ["Home", "General Search"],
      links:['home','sitelookup'],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.setState({loading: false});
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if(nextProps.lookupType && nextProps.responseData && nextProps.responseData){
      this.setState({loading: false});
      let tmpLookupData = Object.assign(this.state.lookupData, {[nextProps.lookupType]:nextProps.responseData});
      this.setState({lookupData : tmpLookupData});
    }
    this.setState({loading: nextProps.loading});
  }

  handleInputChange = event => {
    
     this.setState({isArchiveVoucherLookupActive : (event.target.name == 'archivevoucherID' && event.target.value.length >= 3)});
    this.setState({isVoucherLookupActive : (event.target.name == 'voucherID' && event.target.value.length >= 3)});
    this.setState({isCouponLookupActive : (event.target.name == 'couponID' && event.target.value.length >= 3)});
    this.setState({isAddressLookupActive : (event.target.name == 'address' && event.target.value.length >= 2)});
    this.setState({isTrackingLookupActive : (event.target.name == 'trackingNumber' && event.target.value.length >= 3)});
    this.setState({isTransactionLookupActive : (event.target.name == 'transaction_id' && event.target.value.length >= 3)});
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleResetSearch = searchType => {
    let tmpLookupData = Object.assign(this.state.lookupData, {[searchType]:[]});
    this.setState({lookupData : tmpLookupData});
    if(searchType == 'user'){
      this.setState({firstName : "", lastName: "", email: "", phone: "", orderID: ""});
    }
    if(searchType == 'voucher'){
      this.setState({voucherID : ''});
    }
    if(searchType == 'archivevoucher'){
      this.setState({archivevoucherID : ''});
    }
    if(searchType == 'subscriber'){
      this.setState({subscriber_fname : '', subscriber_lname: '', subscriber_email: ''});
    }
    if(searchType == 'coupon'){
      this.setState({couponID : ''});
    }
    if(searchType == 'shipping'){
      this.setState({address : ''});
    }
    if(searchType == 'tracking'){
      this.setState({trackingNumber : ''});
    }
    if(searchType == 'transaction'){
      this.setState({transaction_id : ''});
    }
  };

  handleFormSubmit(lookupType){
    this.setState({loading: true});
    if(lookupType){
      const {actions: { getLookupData }} = this.props;
      let formData = null;
      if(lookupType == 'user'){
        formData = {firstName: this.state.firstName, lastName: this.state.lastName, email: this.state.email, phone: this.state.phone, orderID: this.state.orderID };
      }
      if(lookupType == 'voucher'){
        formData = {voucherID: this.state.voucherID}
      }
      if(lookupType == 'archivevoucher'){
        formData = {archivevoucherID: this.state.archivevoucherID}
      }
      if(lookupType == 'subscriber'){
        formData = {firstName: this.state.subscriber_fname, lastName: this.state.subscriber_lname, email: this.state.subscriber_email}
      }
      if(lookupType == 'coupon'){
        formData = {couponID: this.state.couponID}
      }
      if(lookupType == 'shipping'){
        formData = {address: this.state.address}
      }
      if(lookupType == 'tracking'){
        formData = {trackingNumber: this.state.trackingNumber}
      }
      if(lookupType == 'transaction'){
        formData = {transaction_id: this.state.transaction_id}
      }
      if(formData){
        getLookupData(formData, lookupType);
      }
    }
  }

  stringUCWord(str) {
    if (str) {
      str = str.replace(/_/g, " ");
      let sText = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
      });
      return sText;
    }
  }

  render() {
    let isUserLookupActive = (this.state.firstName !='' || this.state.lastName !='' || this.state.email !='' || this.state.phone !='' || this.state.orderID !='');
    let isSubscriberLookupActive = (this.state.subscriber_fname !='' || this.state.subscriber_lname !='' || this.state.subscriber_email !='');
    const {lookupData} = this.state;
    let userRow, voucherRow, couponRow, shippingRow, trackingRow, transactionRow, subscriberRow,voucherarchiveRow;
   //  console.log(lookupData);
    if (lookupData.user && !isEmpty(lookupData.user)) {
      userRow = lookupData.user.map((vc, index) => (
        <tr key={vc.uid}>
          <td><a onClick={() => this.context.router.history.push(`/voucherList/${vc.uid}`)}>{this.stringUCWord(vc.firstName)} {this.stringUCWord(vc.lastName)}</a></td>
          <td>{vc.email}</td>
          <td>{vc.phone}</td>
          <td><a onClick={() => this.context.router.history.push(`/addSubAdmin/${vc.uid}`)}>Edit</a></td>
        </tr>
      ));
    }

    if (lookupData.subscriber && !isEmpty(lookupData.subscriber)) {
      subscriberRow = lookupData.subscriber.map((vc, index) => (
        <tr key={vc.subscriberID}>
          <td><a onClick={() => this.context.router.history.push(`/subscriber-edit/${vc.subscriberID}`)}>{this.stringUCWord(vc.firstName)} {this.stringUCWord(vc.lastName)}</a></td>
          <td>{vc.email}</td>
          <td><a onClick={() => this.context.router.history.push(`/subscriber-edit/${vc.subscriberID}`)}>Edit</a></td>
        </tr>
      ));
    }

    if (lookupData.voucher && !isEmpty(lookupData.voucher)) {
      voucherRow = lookupData.voucher.map((vc, index) => (
        <tr key={vc.voucherNumber}>
          <td><a onClick={() => this.context.router.history.push(`/voucherList/${vc.uid}`)}>{vc.voucherNumber}</a></td>
          <td>{vc.merchantName}</td>
          <td>{this.stringUCWord(vc.voucherType)}</td>
        </tr>
      ));
    }

     if (lookupData.archivevoucher && !isEmpty(lookupData.archivevoucher)) {
      voucherarchiveRow = lookupData.archivevoucher.map((vc, index) => (
        <tr key={vc.voucherNumber}>
          <td><a onClick={() => this.context.router.history.push(`/archivevoucherLists/${vc.uid}`)}>{vc.voucherNumber}</a></td>
          <td>{vc.merchantName}</td>
          <td>{this.stringUCWord(vc.voucherType)}</td>
        </tr>
      ));
    }
    if (lookupData.coupon && !isEmpty(lookupData.coupon)) {
      couponRow = lookupData.coupon.map((vc, index) => (
        <tr key={vc.voucherNumber}>
          <td><a onClick={() => this.context.router.history.push(`/voucherList/${vc.uid}`)}>{vc.voucherNumber}</a></td>
          <td>{vc.merchantName}</td>
          <td>{this.stringUCWord(vc.voucherType)}</td>
        </tr>
      ));
    }

    if (lookupData.shipping && !isEmpty(lookupData.shipping)) {
      shippingRow = lookupData.shipping.map((vc, index) => (
        <tr key={vc.voucherNumber}>
          <td><a onClick={() => this.context.router.history.push(`/voucherList/${vc.uid}`)}>{vc.voucherNumber}</a></td>
          <td>{vc.legalName}</td>
          <td>{vc.siteName}</td>
          <td>{vc.shipping_address}</td>
        </tr>
      ));
    }

    if (lookupData.tracking && !isEmpty(lookupData.tracking)) {
      trackingRow = lookupData.tracking.map((vc, index) => (
        <tr key={vc.voucherNumber}>
          <td><a onClick={() => this.context.router.history.push(`/voucherList/${vc.uid}`)}>{vc.voucherNumber}</a></td>
          <td>{vc.trackingNumber}</td>
          <td>{vc.firstName} {vc.lastName}</td>
          <td>{vc.legalName}</td>
        </tr>
      ));
    }

    if (lookupData.transaction && !isEmpty(lookupData.transaction)) {
      transactionRow = lookupData.transaction.map((vc, index) => (
        <tr key={vc.voucherNumber}>
          <td><a onClick={() => this.context.router.history.push(`/voucherList/${vc.uid}`)}>{vc.firstName} {vc.lastName}</a></td>
          <td>{vc.offer}</td>
          <td>${vc.amount}</td>
          <td>{this.stringUCWord(vc.type)}</td>
          <td>{vc.quantity}</td>
          <td>{this.stringUCWord(vc.payment_method)}</td>
          <td>{vc.date}</td>
        </tr>
      ));
    }

    return (
      <div>
        {this.state.loading === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">User Lookup</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.firstName}
                      placeholder="First Name"
                      onChange={this.handleInputChange}
                      name="firstName"
                    />
                  </FormGroup>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.lastName}
                      placeholder="Last Name"
                      onChange={this.handleInputChange}
                      name="lastName"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControl
                      type="text"
                      value={this.state.email}
                      placeholder="Email"
                      onChange={this.handleInputChange}
                      name="email"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControl
                      type="text"
                      value={this.state.phone}
                      placeholder="Phone"
                      onChange={this.handleInputChange}
                      name="phone"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControl
                      type="text"
                      value={this.state.orderID}
                      placeholder="Order ID"
                      onChange={this.handleInputChange}
                      name="orderID"
                    />
                  </FormGroup>
                  <Button bsStyle="info" type="button" onClick={this.handleFormSubmit.bind(this, 'user')} id="saveButton" disabled={!isUserLookupActive}>Search</Button>
                  <Button bsStyle="info" type="button" onClick={this.handleResetSearch.bind(this, 'user')} id="clearButton" >Clear</Button>
                </Col>
                <Col md={9} xs={12}>
                  <div className="row">
                    <div className="col-lg-12">
                      {lookupData.user && lookupData.user.length >0 ? (
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th> Name </th>
                              <th> Email </th>
                              <th> Contact Email </th>
                              <th>  </th>
                            </tr>
                          </thead>
                          <tbody>{userRow}</tbody>
                        </table>) :("")}
                      {lookupData.user && lookupData.user.length ==0 ? (
                        <b>No users were found.</b>
                      ):("")}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Search Subscribers</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.subscriber_fname}
                      placeholder="First Name"
                      onChange={this.handleInputChange}
                      name="subscriber_fname"
                    />
                  </FormGroup>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.subscriber_lname}
                      placeholder="Last Name"
                      onChange={this.handleInputChange}
                      name="subscriber_lname"
                    />
                  </FormGroup>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.subscriber_email}
                      placeholder="Email Address"
                      onChange={this.handleInputChange}
                      name="subscriber_email"
                    />
                  </FormGroup>
                  <Button bsStyle="info" type="button" onClick={this.handleFormSubmit.bind(this, 'subscriber')} id="saveButton" disabled={!isSubscriberLookupActive}>Search</Button>
                  <Button bsStyle="info" type="button" onClick={this.handleResetSearch.bind(this, 'subscriber')} id="clearButton" >Clear</Button>
                </Col>
                <Col md={9} xs={12}>
                  <div className="row">
                    <div className="col-lg-12">
                      {lookupData.subscriber && lookupData.subscriber.length >0 ? (
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th> Name </th>
                              <th> Email </th>
                              <th> Action </th>
                            </tr>
                          </thead>
                          <tbody>{subscriberRow}</tbody>
                        </table>) :("")}
                      {lookupData.subscriber && lookupData.subscriber.length ==0 ? (
                        <b>No vouchers were found.</b>
                      ):("")}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Voucher Lookup</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.voucherID}
                      placeholder="Voucher"
                      onChange={this.handleInputChange}
                      name="voucherID"
                    />
                  </FormGroup>
                  <Button bsStyle="info" type="button" onClick={this.handleFormSubmit.bind(this, 'voucher')} id="saveButton" disabled={!this.state.isVoucherLookupActive}>Search</Button>
                  <Button bsStyle="info" type="button" onClick={this.handleResetSearch.bind(this, 'voucher')} id="clearButton" >Clear</Button>
                </Col>
                <Col md={9} xs={12}>
                  <div className="row">
                    <div className="col-lg-12">
                      {lookupData.voucher && lookupData.voucher.length >0 ? (
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th> Code </th>
                              <th> Merchant </th>
                              <th> Type </th>
                            </tr>
                          </thead>
                          <tbody>{voucherRow}</tbody>
                        </table>) :("")}
                      {lookupData.voucher && lookupData.voucher.length ==0 ? (
                        <b>No vouchers were found.</b>
                      ):("")}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

            <div className="panel">
            <header className="panel-heading" style={{ textTransform: 'none'}}>ARCHIVED VOUCHER LOOKUP (For all vouchers purchased more than 9 months in the past)</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.archivevoucherID}
                      placeholder="Archived Voucher"
                      onChange={this.handleInputChange}
                      name="archivevoucherID"
                    />
                  </FormGroup>
                  <Button bsStyle="info" type="button" onClick={this.handleFormSubmit.bind(this, 'archivevoucher')} id="saveButton" disabled={!this.state.isArchiveVoucherLookupActive}>Search</Button>
                  <Button bsStyle="info" type="button" onClick={this.handleResetSearch.bind(this, 'archivevoucher')} id="clearButton" >Clear</Button>
                </Col>
                <Col md={9} xs={12}>
                  <div className="row">
                    <div className="col-lg-12">
                      {lookupData.archivevoucher && lookupData.archivevoucher.length >0 ? (
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th> Code </th>
                              <th> Merchant </th>
                              <th> Type </th>
                            </tr>
                          </thead>
                          <tbody>{voucherarchiveRow}</tbody>
                        </table>) :("")}
                      {lookupData.archivevoucher && lookupData.archivevoucher.length ==0 ? (
                        <b>No vouchers were found.</b>
                      ):("")}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Coupon Lookup</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.couponID}
                      placeholder="Coupon"
                      onChange={this.handleInputChange}
                      name="couponID"
                    />
                  </FormGroup>
                  <Button bsStyle="info" type="button" onClick={this.handleFormSubmit.bind(this, 'coupon')} id="saveButton" disabled={!this.state.isCouponLookupActive}>Search</Button>
                  <Button bsStyle="info" type="button" onClick={this.handleResetSearch.bind(this, 'coupon')} id="clearButton" >Clear</Button>
                </Col>
                <Col md={9} xs={12}>
                  <div className="row">
                    <div className="col-lg-12">
                      {lookupData.coupon && lookupData.coupon.length >0 ? (
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th> Code </th>
                              <th> Merchant </th>
                              <th> Type </th>
                            </tr>
                          </thead>
                          <tbody>{couponRow}</tbody>
                        </table>) :("")}
                      {lookupData.coupon && lookupData.coupon.length ==0 ? (
                        <b>No coupons were found.</b>
                      ):("")}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Shipping Address Lookup</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.address}
                      placeholder="Shipping Address"
                      onChange={this.handleInputChange}
                      name="address"
                    />
                  </FormGroup>
                  <Button bsStyle="info" type="button" onClick={this.handleFormSubmit.bind(this, 'shipping')} id="saveButton" disabled={!this.state.isAddressLookupActive}>Search</Button>
                  <Button bsStyle="info" type="button" onClick={this.handleResetSearch.bind(this, 'shipping')} id="clearButton" >Clear</Button>
                </Col>
                <Col md={9} xs={12}>
                  <div className="row">
                    <div className="col-lg-12">
                      {lookupData.shipping && lookupData.shipping.length >0 ? (
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th> Code </th>
                              <th> Merchant </th>
                              <th> Site </th>
                              <th> Shipping Address </th>
                            </tr>
                          </thead>
                          <tbody>{shippingRow}</tbody>
                        </table>) :("")}
                      {lookupData.shipping && lookupData.shipping.length ==0 ? (
                        <b>No shipping address were found.</b>
                      ):("")}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Tracking Number Lookup</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.trackingNumber}
                      placeholder="Tracking Number"
                      onChange={this.handleInputChange}
                      name="trackingNumber"
                    />
                  </FormGroup>
                  <Button bsStyle="info" type="button" onClick={this.handleFormSubmit.bind(this, 'tracking')} id="saveButton" disabled={!this.state.isTrackingLookupActive}>Search</Button>
                  <Button bsStyle="info" type="button" onClick={this.handleResetSearch.bind(this, 'tracking')} id="clearButton" >Clear</Button>
                </Col>
                <Col md={9} xs={12}>
                  <div className="row">
                    <div className="col-lg-12">
                      {lookupData.tracking && lookupData.tracking.length >0 ? (
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th> Code </th>
                              <th> Tracking Number </th>
                              <th> User </th>
                              <th> Merchant </th>
                            </tr>
                          </thead>
                          <tbody>{trackingRow}</tbody>
                        </table>) :("")}
                      {lookupData.tracking && lookupData.tracking.length ==0 ? (
                        <b>No such tracking number found.</b>
                      ):("")}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Paypal Transaction ID Lookup</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <FormGroup >
                    <FormControl
                      type="text"
                      value={this.state.transaction_id}
                      placeholder="Paypal Transaction ID"
                      onChange={this.handleInputChange}
                      name="transaction_id"
                    />
                  </FormGroup>
                  <Button bsStyle="info" type="button" onClick={this.handleFormSubmit.bind(this, 'transaction')} id="saveButton" disabled={!this.state.isTransactionLookupActive}>Search</Button>
                  <Button bsStyle="info" type="button" onClick={this.handleResetSearch.bind(this, 'transaction')} id="clearButton" >Clear</Button>
                </Col>
                <Col md={9} xs={12}>
                  <div className="row">
                    <div className="col-lg-12">
                      {lookupData.transaction && lookupData.transaction.length >0 ? (
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th> User </th>
                              <th> Offer </th>
                              <th> Amount </th>
                              <th> Type </th>
                              <th> Quantity </th>
                              <th> Date </th>
                            </tr>
                          </thead>
                          <tbody>{transactionRow}</tbody>
                        </table>) :("")}
                      {lookupData.transaction && lookupData.transaction.length ==0 ? (
                        <b>No such transaction id found.</b>
                      ):("")}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.siteReducer.loading,
    error: state.siteReducer.error,
    responseData: state.siteReducer.responseData,
    lookupType: state.siteReducer.lookupType,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiteLookup));



// WEBPACK FOOTER //
// ./src/app/views/admin/generalSearch/SiteLookup.js